import { useEffect, useState } from "react";
import { Select, Radio } from "antd";
import type { CheckboxGroupProps } from "antd/es/checkbox";
import "./styles.scss";
const options = [
    { label: "All", value: "All" },
    { label: "MT5", value: "mt5" },
    { label: "MT4", value: "mt4" },
    { label: "cTrader", value: "ctrader" },
];

const SortOptions = [
    { label: "Balance", value: "balance" },
    { label: "Creation Date", value: "create_at" },
    { label: "Profit", value: "profit" },
];

const SortDirectionOptions = [
    { label: "Ascending", value: "asc" },
    { label: "Descending", value: "desc" },
];

interface FillterOptionsProps {
    selectedBroker: string;
    setSelectedBroker: (broker: string) => void;
    selectedPlatform: string;
    setSelectedPlatform: (platform: string) => void;
    setSortOption: (option: "balance" | "create_at" | "profit" | null) => void;
    sortOption: "balance" | "create_at" | "profit" | null;
    sortDirection: "asc" | "desc";
    setSortDirection: (direction: "asc" | "desc") => void;
}
const FillterOptions: React.FC<FillterOptionsProps> = ({
    selectedBroker,
    setSelectedBroker,
    selectedPlatform,
    setSelectedPlatform,
    sortOption,
    setSortOption,
    sortDirection,
    setSortDirection
}) => {
    const [brokerList, setBrokerList] = useState<string[]>(["FTMO", "Ecmarkets","IC Markets"]);

    useEffect(() => {
        // Fetch broker and platform lists from an API or local data source
        const fetchData = async () => {
            const res = await fetch(
                "https://fund-forge-api.wealthfarming.org/terminal-accounts/brokers",
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await res.json();
            if (!res.ok) {
                setBrokerList([
                    "FTMO", "Ecmarkets","IC Markets"
                ]);
                return;
            }
            setBrokerList(data.data);
        };
        fetchData();
    }, []);
    return (
        <div className="flex flex-1 flex-wrap gap-4 mb-4">
            <div className="flex flex-row flex-1 items-center gap-2">
                <p className="m-0" style={{ color: 'var(--text-title)' }}>Broker:</p>
                <Select
                    value={selectedBroker}
                    onChange={(value: string) => setSelectedBroker(value)}
                    style={{ width: 220, borderRadius: 8 }}
                    placeholder="All"
                    options={[
                        { label: "All", value: "All" },
                        ...brokerList.map((b) => ({ label: b, value: b })),
                    ]}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                        (option?.label ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{
                        borderRadius: 8,
                        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                    }}
                />
            </div>
            <div className="flex flex-row flex-1 items-center gap-2">
                <p className="m-0" style={{ color: 'var(--text-title)' }}>Platform:</p>
                {options.map((opt) => (
                    <div
                        key={opt.value}
                        className={`flex tradePlatform-select items-center cursor-pointer ${selectedPlatform === opt.value ? "active" : ""
                            }`}
                        onClick={() => setSelectedPlatform(opt.value)}
                    >
                        <span className="tradePlatform-select-lable"> {opt.label} </span>
                    </div>
                ))}
            </div>
            <div className="flex flex-row flex-1 items-center gap-2">
                <p className="m-0" style={{ color: 'var(--text-title)' }}>Sort: </p>
                <Select
                    value={sortOption || "create_at"}
                    onChange={(value: string) => setSortOption(value as "balance" | "create_at" | "profit")}
                    style={{ width: 150, borderRadius: 8 }}
                    placeholder="All"
                    options={[
                        ...SortOptions,
                    ]}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                        (option?.label ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{
                        borderRadius: 8,
                        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                    }}
                />
                <div className="flex flex-row flex-1 items-center gap-2">
                    <Select
                        value={sortDirection || "desc"}
                        onChange={(value: string) => setSortDirection && setSortDirection(value as "asc" | "desc")}
                        style={{ width: 150, borderRadius: 8 }}
                        placeholder="All"
                        options={[
                            ...SortDirectionOptions,
                        ]}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            (option?.label ?? "")
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{
                            borderRadius: 8,
                            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                        }}
                        className="bg-white"
                    />
                </div>
            </div>
        </div>
    );
};

export default FillterOptions;
